import {createFileRoute, Outlet, useNavigate} from '@tanstack/react-router'
import {useEffect} from 'react'

export const Route = createFileRoute('/_app/rydercup/$uid')({
    component: RouteComponent,
})

function RouteComponent() {
    const {uid} = Route.useParams()
    const navigate = useNavigate()
    const hasChildRoute = !!(Route.useMatch as any)()?.childMatches?.length

    useEffect(() => {
        if (!hasChildRoute) {
            navigate({to: `/rydercup/${uid}/dashboard`, replace: true})
        }
    }, [uid, hasChildRoute])

    return <Outlet />
}
